// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_61b2439","activeTableButton":"_01b03db","badge":"_c57078f"};